import React from 'react';
import { withFormsy } from 'formsy-react';
import _ from 'lodash';
import { InputLabel, Radio, RadioGroup, FormHelperText, FormControlLabel } from '@mui/material';

export class RadioInput extends React.Component {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    this.props.setValue(event.target.value);
  }

  render() {
    const { name, label, required, options, hint, value, errorMessage, isPristine } = this.props;
    const isError = !isPristine && errorMessage != null;

    return (
      <div className="input-container">
        <InputLabel id={`radio${name}`} error={isError} required={required} style={{textWrap: 'auto'}}>{label}</InputLabel>
        <RadioGroup
          id={name}
          name={name}
          onChange={this.changeValue}
          value={value || ""}
          aria-labelledby={`radio${name}`}
        >
          {options.map((option, i) => (
            _.isString(option) ?
              <FormControlLabel key={i} value={option} control={<Radio slotProps={{input: {'aria-labelledby': `radio${name}`}}} />} label={option} />
            :
              <FormControlLabel key={i} value={option.value} control={<Radio slotProps={{input: {'aria-labelledby': `radio${name}`}}} />} label={option.label} />
          ))}
        </RadioGroup>

        <span aria-live="polite">
          {!isPristine && errorMessage &&
            <FormHelperText error={isError}>{errorMessage}</FormHelperText>
          }
        </span>
        {hint &&
          <FormHelperText >{hint}</FormHelperText>
        }
      </div>
    );
  }
}

export default withFormsy(RadioInput);
